import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  pageContent: {
    backgroundColor: "#F0F2F5",
    width: "100%",
    height: "80%",
    borderRadius: "10px 10px 10px 10px",
    boxSizing: "border-box",
    paddingTop: "16px",
    paddingLeft: "16px",
    paddingRight: "16px",
    "@media (max-width: 550px)": {
      paddingTop: 0
    }
  },
  drawerContainer: {
    maxWidth: 450,
    padding: "24px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "@media (max-width: 550px)": {
      minWidth: "100vw",
      maxWidth: "100%"
    }
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px"
  },
  title: {
    fontWeight: 700,
    fontSize: "18px"
  },
  closeButton: {
    color: "black",
    backgroundColor: "#F3F4F6",
    borderRadius: "50%",
    padding: "4px"
  },
  card: {
    border: "1px solid #E5E7EB",
    borderRadius: "12px",
    padding: "10px",
    marginBottom: "16px"
  },
  cardTitle: {
    fontSize: "14px",
    fontWeight: 600,
    marginBottom: "8px"
  },
  flexColumn: {
    background: "#FAFAFA",
    padding: "10px"
  },
  gridRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "12px",
    alignItems: "center",
    gap: "3.5rem",
    "@media (max-width: 550px)": {
      gap: "1rem"
    }
  },
  label: {
    color: "#6B7280",
    fontSize: "13px"
  },
  value: {
    fontSize: "13px",
    fontWeight: 500
  },
  statusBadge: {
    backgroundColor: "#DCFCE7",
    color: "#166534",
    padding: "4px 8px",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: 600,
    textTransform: "capitalize"
  }
}));
